import React, { useState } from "react"
import { Row, Col, Spin, message, Upload, Modal } from "antd"
import { ImportStyled } from "./styled"
import SvgIcon from "src/components/SvgIcon"
import dayjs from "dayjs"

const { Dragger } = Upload

const  ImportModal = ({
  open,
  setRefresh,
  onCancel,
  apiDownloadTemplate,
  apiUploadTemplate,
  filenameTemplate = "Danh_sach_Kho_de_xuat",
  recordId,
}) => {
  const [loading, setLoading] = useState(false)
  const [uploadErrors, setUploadErrors] = useState([])
  const [errorModalVisible, setErrorModalVisible] = useState(false)
  const [uploadMessage, setUploadMessage] = useState("")

  const handleUpload = async file => {
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append("file", file)
      let response = undefined
      console.log(recordId)
      if (recordId) {
        response = await apiUploadTemplate(recordId, formData)
      } else {
        response = await apiUploadTemplate(formData)
      }
      // Xử lý khi thành công
      if (!response?.error) {
        let messageText = ""
        if (typeof response === "string") {
          messageText = response
        } else {
          messageText =
            response?.message || response?.data?.message || "Upload thành công!"
        }

        message.success(messageText)
        onCancel()
        setRefresh(prev => !prev)
      } else {
        // Xử lý khi thất bại
        if (Array.isArray(response.errors)) {
          setUploadErrors(response.errors)
          setErrorModalVisible(true)
          setUploadMessage(response.message)
        } else {
          message.error(response.message || "Upload thất bại!")
        }
      }
    } catch (error) {
      console.error("Upload error:", error)
      message.error("Lỗi hệ thống, vui lòng thử lại!")
    } finally {
      setLoading(false)
    }
  }

  const uploadProps = {
    name: "file",
    multiple: false,
    accept: ".xlsx, .xls, .xlsm",
    customRequest({ file, onSuccess, onError }) {
      handleUpload(file)
        .then(() => onSuccess("ok"))
        .catch(err => onError(err))
    },
    showUploadList: false,
  }

  const handleDownloadTemplate = async () => {
    try {
      const response = await apiDownloadTemplate()
      const url = URL.createObjectURL(response)
      const link = document.createElement("a")
      const date = dayjs().format("DD-MM-YYYY")
      const filename = `${filenameTemplate}_${date}.xlsx`
      link.href = url
      link.setAttribute("download", filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error) {
      console.error("Download template error:", error)
      message.error("Không thể tải file mẫu.")
    }
  }

  return (
    <>
      <ImportStyled>
        <Spin spinning={loading}>
          {apiDownloadTemplate && (
            <div style={{ marginBottom: 10 }}>
              Tải file mẫu{" "}
              <span
                onClick={handleDownloadTemplate}
                style={{
                  color: "#154398",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                tại đây
              </span>
            </div>
          )}

          <Dragger {...uploadProps}>
            <Row gutter={20} justify="center">
              <Col>
                <SvgIcon name="cloud" />
              </Col>
              <Col>
                <span>
                  Kéo thả file đính kèm hoặc{" "}
                  <span style={{ color: "#154398" }}>chọn file</span>
                </span>
              </Col>
            </Row>
          </Dragger>

          <Row className="box-note pt-15" align="middle">
            <Col>
              <SvgIcon name="warningCKS" />
            </Col>
            <Col className="ml-10">
              Lưu ý: Tải lên file đúng định dạng hệ thống yêu cầu.
            </Col>
          </Row>
        </Spin>
      </ImportStyled>

      <Modal
        title={
          <span style={{ color: "#cf2e2e", fontWeight: "bold" }}>
            Danh sách lỗi khi tải lên
          </span>
        }
        open={errorModalVisible}
        onCancel={() => setErrorModalVisible(false)}
        footer={null}
        width={600}
      >
        <div style={{ marginBottom: 12, fontSize: 15, color: "#333" }}>
          {uploadMessage ||
            "Một số dòng trong file không hợp lệ. Vui lòng kiểm tra:"}
        </div>

        <div
          style={{
            maxHeight: 300,
            overflowY: "auto",
            border: "1px solid #f0f0f0",
            borderRadius: 6,
            padding: 12,
            background: "#fffbe6",
          }}
        >
          {uploadErrors.map((err, idx) => (
            <p key={idx} style={{ color: "#d32029", marginBottom: 8 }}>
              {err.row? `Dòng ${err.row}: ${err.message}` : err}
            </p>
          ))}
        </div>

        <div style={{ textAlign: "right", marginTop: 16 }}>
          <button
            onClick={() => setErrorModalVisible(false)}
            style={{
              padding: "6px 16px",
              backgroundColor: "#d32029",
              color: "#fff",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            Đóng
          </button>
        </div>
      </Modal>
    </>
  )
}

export default ImportModal
